import { Component } from '@angular/core';
import { NotificationsWidget } from './components/notificationswidget';
import { StatsWidget } from './components/statswidget';
import { RecentSalesWidget } from './components/recentsaleswidget';
import { BestSellingWidget } from './components/bestsellingwidget';
import { RevenueStreamWidget } from './components/revenuestreamwidget';
import { DashboardActiveDailyComponent } from "@/project/dashbord/report-customer-active/report-customer-active";
import { ExpiringEnrollmentsPage } from "@/project/expiring-enrollments/expiring-enrollments";
import { ExpiringEnrollmentsReportPage } from "@/project/expiring-enrollments/expiring-enrollments-report.page";

@Component({
    selector: 'app-dashboard',
    imports: [StatsWidget, RecentSalesWidget, BestSellingWidget, RevenueStreamWidget, NotificationsWidget, DashboardActiveDailyComponent, ExpiringEnrollmentsPage, ExpiringEnrollmentsReportPage],
    template: `
        <div class="grid grid-cols-12 gap-8">
            <app-stats-widget class="contents" />

            <div class="col-span-12 xl:col-span-6">
            </div> 

            <div class="col-span-12 xl:col-span-6">
            </div> 

            <!-- Banner Image -->
            <div class="col-span-12">
                <img 
                    src="assets/images/shadab.webp" 
                    alt="Shadab Banner"
                    class="w-full h-auto rounded-xl"
                />
            </div>

        </div>
    `
})
export class Dashboard {}
